import styled, { css } from "styled-components";
import { media } from "../../layouts/utils";
import { colorBrandPrimary } from "../../global.style";

const blur = `
  -webkit-filter: blur(5px);
  -moz-filter: blur(5px);
  -o-filter: blur(5px);
  -ms-filter: blur(5px);
  filter: blur(10px);
  pointer-events: none;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
`;

export const ContainerList = styled.div`
	display: flex;
	${({ maxOffer }) =>
		maxOffer
			? css`
					justify-content: space-between;
			  `
			: css`
					justify-content: center;
					& > div {
						margin-right: 24px;
					}

					& > div:last-child {
						margin-right: 0;
					}

					${media.phone`
                & > div:nth-child(n+1) {
                    margin: 0;
                    width: 100%;

                    &:only-child > div > div:last-child {
                        flex-direction: row;
                    }
                }
            `}
			  `};

	width: 90%;
	margin-top: 10px;
	padding-bottom: 10px;
	padding-right: 10px;

	${media.phone`
        width: 100%;
        padding: 0 0 18px 24px;
        max-width: 100%;
        overflow-x: auto;
        overflow-y: hidden;
    `}
`;
export const ContainerCTA = styled.div`
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
	padding-bottom: 50px;
	${props => props.blur && blur}
	& button {
		padding: 0 50px;
		min-width: 150px;
	}
	.botoesCupons {
		display: flex;
		gap: 2rem;
		${media.phone`
			flex-direction: column !important;
			gap: 1rem;
 		`}
	}

	${media.desktop`
    flex-direction: column;
    & button {
      min-width: 100%;
			& span {
				font-size: 16px;
			}
    }
  `}

	${media.large`
        & button {
            font-size:80%;
            transform: scale(0.95)
        }
    `}
`;

export const CardLink = styled.div`
	margin-top: 20px;
	${props => props.blur && blur}
`;

export const CheckboxContainer = styled.div`
	display: flex;
	font-size: 14px;
	color: ${colorBrandPrimary.marine};
	padding-bottom: 30px;
	${props => props.blur && blur};
	.underline {
		font-weight: bold;
		text-decoration: underline;
		cursor: pointer;
	}

	${media.phone`
		padding: 24px;
	`}
`;
